var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$root.$data.isApp && !this.$root.miniprogram )?_c('div',{staticClass:"appDownComponent"},[_c('Btn',{attrs:{"title":"去启航教育app,领取更多优质好课","btnWidth":"90%"},nativeOn:{"click":function($event){return _vm.goApp.apply(null, arguments)}}}),_c('WxShare',{ref:"share"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }